import { Card, CardContent } from "@/components/ui/card";
import { formatRewardAmount } from "@/lib/textUtils";
import iconRewards from "@/assets/rewards/icon_rewards.svg";

interface RewardCardProps {
  rewardAmount: number;
  className?: string;
  isMobile?: boolean;
}

export function RewardCard({ rewardAmount, className = "", isMobile = false }: RewardCardProps) {
  return (
    <Card 
      className={`border-0 shadow-sm text-white ${className}`}
      style={{ backgroundColor: '#2D2D2D' }}
    >
      <CardContent 
        className={isMobile ? "p-3 sm:p-4" : "p-4 h-full flex flex-col justify-center"}
        style={{
          display: 'flex',
          padding: isMobile ? undefined : '16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '8px'
        }}
      >
        <img 
          src={iconRewards} 
          alt="Client Referral Reward"
          className={isMobile ? "h-5 w-5 sm:h-6 sm:w-6" : "h-7 w-7"}
          style={{filter: 'brightness(0) saturate(100%) invert(100%)'}}
        />
        <p className={isMobile ? "text-fluid-lg lg:text-2xl font-bold space-grotesk text-white" : "text-3xl font-bold space-grotesk text-white"}>
          R{formatRewardAmount(rewardAmount)}
        </p>
        <p className="text-xs font-medium uppercase leading-tight tracking-[0.07px] text-gray-400">
          CLIENT REFERRAL REWARD
        </p>
        <p className={`text-xs text-gray-400 ${isMobile ? "mt-1" : "mt-2"}`}>
          Earn this reward when your referred company becomes a client
        </p>
      </CardContent>
    </Card>
  );
}
